enum ErrorCodes {
  // Fetch Errors
  FetchOffersError = 'FSPO-ERR',
  FetchDealersError = 'FDES-ERR',
  FetchServiceOffersError = 'FSEO-ERR',
  FetchLocationError = 'FLOC-ERR'
}

export default ErrorCodes;
